import { ActionTypes } from './action-types.enum';

const initialState = {
  templates: [],
  defaultSelectedTemplateId: undefined,
  lastUsedTemplates: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_TEMPLATES:
      const preparedState = {
        ...state,
        templates: action.payload?.templates || [],
      };
      if (
        Object.keys(state.lastUsedTemplates).length === 0
        && action.payload?.templates?.length > 0
      ) {
        const latestTemplates = {};
        const randomTempls = action.payload?.templates.slice(0, 3);
        randomTempls.forEach((templ) => {
          latestTemplates[templ.id] = templ;
        });

        preparedState.lastUsedTemplates = latestTemplates;
      }

      if (
        !state.defaultSelectedTemplateId
        && action.payload?.templates?.length
      ) {
        preparedState.defaultSelectedTemplateId = action.payload.templates[0].id;
      }

      return preparedState;
    case ActionTypes.SET_DEFAULT_TEMPLATE:
      return {
        ...state,
        defaultSelectedTemplateId: action.payload?.templateId,
      };
    case ActionTypes.SET_LAST_USED_TEMPLATE:
      if ((state.lastUsedTemplates && Object.keys(state.lastUsedTemplates).length >= 3)) {
        const lastUsedTemplsKeys = Object.keys(state.lastUsedTemplates);
        const lastUsedTempls = state.lastUsedTemplates;
        if (!lastUsedTempls[action.payload?.lastUsedTemplateId]) {
          delete lastUsedTempls[lastUsedTemplsKeys[0]];

          return {
            ...state,
            lastUsedTemplates: {
              ...lastUsedTempls,
              [action.payload?.lastUsedTemplateId]: action.payload?.template,
            },
          };
        } else {
          delete lastUsedTempls[action.payload?.lastUsedTemplateId];
          return {
            ...state,
            lastUsedTemplates: {
              ...lastUsedTempls,
              [action.payload?.lastUsedTemplateId]: action.payload?.template,
            },
          };
        }
      } else {
        return {
          ...state,
          lastUsedTemplates: {
            ...state.lastUsedTemplates,
            [action.payload?.lastUsedTemplateId]: action.payload?.template,
          },
        };
      }
    default:
      return state;
  }
};
